<template>
    <div>
      <div class="header">
        <div class="clock">{{clock}}</div>
      </div>
      <DeparturesTable :panelConfig="panelConfig" :stopData="stopData"></DeparturesTable>
    </div>
</template>

<script>
import DeparturesTable from './DeparturesTable';

export default {
  components: {
    DeparturesTable
  },
  props: ['panelConfig', 'stopData', 'clock'],
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: center;
}
@media only screen and (min-width: 600px) {
  .clock {
    font-size: 5.7em;
    line-height: 1em;
  }
}
</style>